export enum TServiceQuestionType {
  TEXT = 'text',
  TEXTAREA = 'textarea',
  FILE = 'file',
  SELECT = 'select',
}

export const SERVICE_QUESTION_TYPE_OPTIONS: Record<TServiceQuestionType, string> = {
  [TServiceQuestionType.TEXT]: 'テキスト（1行）',
  [TServiceQuestionType.TEXTAREA]: 'テキスト（複数行）',
  [TServiceQuestionType.FILE]: 'ファイル添付',
  [TServiceQuestionType.SELECT]: '選択肢',
}

export type TServiceQuestionOption = {
  value: string
  label: string
}

export type TServiceQuestion = {
  id: string
  label: string
  description?: string
  type: TServiceQuestionType
  required: boolean
  placeholder?: string
  options?: TServiceQuestionOption[]
}
